import CryptoJS from "crypto-js";

class EncryptionService {
  private key: string;

  constructor() {
    // בזמן הבנייה, Vite מחליף את זה עם הערך האמיתי
    const key = import.meta.env.VITE_ENCRYPTION_KEY;

    // אם אין ערך, ננסה לקחת מהwindow (למקרה שהוגדר בruntime)
    if (
      !key &&
      typeof window !== "undefined" &&
      (window as any).ENV?.ENCRYPTION_KEY
    ) {
      this.key = (window as any).ENV.ENCRYPTION_KEY;
      return;
    }

    if (!key) {
      throw new Error("VITE_ENCRYPTION_KEY is not defined");
    }

    this.key = key;
  }

  encrypt(text: string): string {
    return CryptoJS.AES.encrypt(text, this.key).toString();
  }

  decrypt(encryptedText: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedText, this.key);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}

export const encryptionService = new EncryptionService();
